import React from 'react';
import { Outlet } from 'react-router-dom';
import DashboardHeader from './DashboardHeader';
import AnnouncementBanner from './AnnouncementBanner';
import Footer from './Footer';
import { DashboardNavigationProvider } from '../../context/DashboardNavigationContext';
import { SearchProvider } from '../../context/SearchContext';
import { useAuth } from '../../context/AuthContext';
import SkipLink from '../common/SkipLink';
import styles from './DashboardLayout.module.css';

const DashboardLayout: React.FC = () => {
  const { user } = useAuth();
  const userType = user && 'type' in user ? (user as any).type as 'client' | 'contractor' : undefined;

  return (
    <SearchProvider>
    <DashboardNavigationProvider>
      <div className={styles.layout} style={{ backgroundColor: '#f8fafc' }}>
        <SkipLink />
        <AnnouncementBanner userType={userType} />
        <DashboardHeader />
        <main
          id="main-content"
          tabIndex={-1}
          className={styles.dashboardContent}
          style={{ outline: 'none' }}
        >
          <Outlet />
        </main>
        <Footer />
      </div>
    </DashboardNavigationProvider>
    </SearchProvider>
  );
};

export default DashboardLayout;
